import React, { useContext, useState } from 'react';
import { StateStore } from '../store';
import './WeeklyCard.scss';
import { syncStatiDate, editPrayerStatus } from '../Actions/UserActions';
import { names } from '../Data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarWeek, faHistory } from '@fortawesome/free-solid-svg-icons';
import Loading from './Loading';
import PrayerModal from './PrayerModal';
import StatiModal from './StatiModal';

// const getIndexedForm = (_stati = []) => {
//   if (_stati.length === 0) return null;
//   const obj = {};
//   _stati.forEach(status => obj[new Date(status.unixTimestamp).toDateString()] = status);
//   return obj;
// }

function shouldUpdateStati(stati) {
  const lastStatus = stati[stati.length - 1];
  if (lastStatus.timestamp) return new Date().toDateString() !== new Date(lastStatus.timestamp).toDateString()
  else return new Date().toLocaleDateString(lastStatus.locale) !== lastStatus.date
}

function isDateToday(date) {
  return new Date().toDateString() === new Date(date).toDateString();
}

export default function WeeklyCard(props) {
  const { dispatch, state: { stati, user, preferences } } = useContext(StateStore);
  const [statusModalState, setStatusModalState] = useState(false);
  const [statiModalState, setStatiModalState] = useState(false);
  const [prayerState, setPrayerState] = useState({});

  // const displayAtOnce = 7;
  // const min = new Date();
  // min.setDate(min.getDate() - displayAtOnce + 1);
  // const [dateRange, setDateRange] = useState({
  //   min: min.toDateString(),
  //   max: new Date().toDateString()
  // });
  // const [allStati, setAllStati] = useState(getIndexedForm(stati));
  // const [isFetching, setIsFetching] = useState(false);

  // useEffect(() => {
  //   if (stati)
  //     setAllStati({ ...allStati, ...getIndexedForm(stati) });
  //   else setAllStati(null);
  // }, [stati]);

  if (!stati) return (
    // if (!stati || !allStati) return (
    <div className="card weekly-card dark loading">
      <Loading bright></Loading>
    </div>
  )

  //if latest date in data is not today, add today's entry and remove first oldest entry
  if (shouldUpdateStati(stati)) {
    syncStatiDate(dispatch, stati, user);
  }

  // const fetchStati = (direction) => {
  //   let d1, d2;
  //   if (direction === -1) {
  //     d1 = new Date(dateRange.min);
  //     d2 = new Date();
  //     d2.setDate(d1.getDate() - 7);
  //     setIsFetching("prev");
  //   } else {
  //     d2 = new Date(dateRange.max);
  //     d1 = new Date();
  //     d1.setDate(Math.min(d2.getDate() + 8, new Date().getDate()));
  //     d2.setDate(d1.getDate() - 6);
  //     setIsFetching("next");
  //   }

  //   fire.firestore()
  //     .collection('users')
  //     .doc(user.uid)
  //     .collection('stati')
  //     .where("unixTimestamp", ">=", d2.getTime())
  //     .where("unixTimestamp", "<=", d1.getTime())
  //     .get().then(resp => {
  //       const data = resp.docs.map(doc => doc.data());
  //       setIsFetching(false);
  //       if (data.length === 0) return console.log("none");
  //       console.log(getIndexedForm(data));
  //       setAllStati({ ...allStati, ...getIndexedForm(data) });
  //       setDateRange({
  //         min: new Date(data[0].unixTimestamp).toDateString(),
  //         max: new Date(data[data.length - 1].unixTimestamp).toDateString()
  //       });
  //     }).catch(console.log);
  // }

  let dayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  // let statuses = ['o', 'd', 'm', 'n'];

  let statiToShow = [...stati];
  // let date = new Date(dateRange.min);
  // for (let i = 0; i < displayAtOnce; i++) {
  //   if (allStati[date.toDateString()])
  //     statiToShow.push(allStati[date.toDateString()])
  //   date.setDate(date.getDate() + 1);
  // }

  const status = names.map(name => statiToShow.map(status => status[name])); //usable format
  // const day = new Date(statiToShow[statiToShow.length - 1].timestamp || statiToShow[statiToShow.length - 1].date).getDay();
  const days = statiToShow.map(status => dayNames[new Date(status.unixTimestamp).getDay()]);
  const editStatus = (name, status, dayIndex) => {
    // status = statuses[(statuses.indexOf(status) + 1) % statuses.length];
    editPrayerStatus(user, statiToShow[dayIndex].uid, name, status);
  }

  return (
    <div className="card weekly-card dark">
      {
        !statusModalState ? null :
          <PrayerModal theme={preferences.theme} save={(formData, char) => { editStatus(formData.name, char, prayerState.dayIndex) }} prayerState={prayerState} modalIsOpen={statusModalState} toggle={setStatusModalState}></PrayerModal>
      }
      {
        !statiModalState ? null :
          <StatiModal theme={preferences.theme} modalIsOpen={statiModalState} toggle={setStatiModalState}></StatiModal>
      }
      <div className="heading" style={{ position: "relative" }}>
        {/* <span style={{ left: "1rem", position: "absolute" }} className="clickable">
          {isFetching !== 'prev' ?
            <FontAwesomeIcon icon={faArrowLeft} className='clickable-icon' onClick={() => fetchStati(-1)}></FontAwesomeIcon> :
            <Loading bright={preferences.theme === 'dark'} mini></Loading>}
        </span> */}
        <span>
          <FontAwesomeIcon icon={faCalendarWeek}></FontAwesomeIcon>
          <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>This Week</span>
          <FontAwesomeIcon icon={faHistory} className="icon" onClick={() => setStatiModalState(true)}></FontAwesomeIcon>
        </span>
        {/* <span>
          {new Date(statiToShow[0].timestamp).toDateString().slice(4, 10) + " to " + new Date(statiToShow[statiToShow.length - 1].timestamp).toDateString().slice(4, 10)}
        </span>
        {new Date().toDateString() !== dateRange.max ?
          <span style={{ right: "1rem", position: "absolute" }} className="clickable">
            {isFetching !== 'next' ?
              <FontAwesomeIcon icon={faArrowRight} className='clickable-icon' onClick={() => fetchStati(+1)}></FontAwesomeIcon> :
              <Loading bright={preferences.theme === 'dark'} mini></Loading>}
          </span>
          : null */}
      </div>
      <div className="grid" style={{ gridTemplateColumns: `repeat(${days.length + 1}, 1fr)` }}>
        <span></span>
        {stati.map((dayStatus, i) => {
          const date = new Date(dayStatus.unixTimestamp);
          return <span key={dayStatus.uid} className={"date" + ((isDateToday(statiToShow[i].timestamp || statiToShow[i].date)) ? " today primary" : "")}>
            {date.getDate()}/{date.getMonth()}
          </span>
        })}
        <span></span>
        {days.map((day, i) => (<span key={day + "." + i} className={"day" + ((isDateToday(statiToShow[i].timestamp || statiToShow[i].date)) ? " today primary" : "")}>{day}</span>))}
        {status.map(status2 => {
          const name = names[status.indexOf(status2)];
          return (
            [<span className="prayerName" key={name}><span>{name}</span></span>,
            status2.map((char, i) => (
              // <FontAwesomeIcon className={"status o"} icon={faCheck}></FontAwesomeIcon>
              <span
                key={name + "." + i}
                className={"status " + char}
                onClick={() => { setPrayerState({ name, status: char, dayIndex: i, timestamp: statiToShow[i].unixTimestamp }); setStatusModalState(true); }}
              // onClick={() => editStatus(name, char, i)}
              >
              </span>
            ))]
          )
        })}
      </div>
      <div className="key">
        <span><div className="status o dormant"></div>Timely</span>
        <span><div className="status d dormant"></div>Delayed</span>
        <span><div className="status m dormant"></div>Missed</span>
      </div>
    </div>
  )
}
